<template>
  <div class="bg-blue-900 text-white py-12">
    <div class="container mx-auto">
      <div class="flex flex-col md:flex-row items-start justify-between">
        <div class="order-last md:order-first">
          <div class="order-first md:order-last mb-4 md:mb-2">
            <a href="https://www.philasd.org" target="_blank">
              <img
                class="w-56"
                alt="The School District of Philadelphia"
                src="~/assets/images/logo-white.png"
              />
            </a>
          </div>
          <div>
            440 N. Broad Street
            <br />Philadelphia, PA 19130 <br />215-400-4000
          </div>
          <div class="mt-4">
            Version 2.5.0 <br />
            Last Updated: 9.15.2026
          </div>
        </div>
        <div v-if="haslinks" class="mb-4 md:mb-0">
          <Navigation :footer="true" />
        </div>
        <div class="mb-4 md:mb-0">
          <div class="pb-2">
            School Profiles are managed by the
            <a
              class="underline"
              href="https://www.philasd.org/era/"
              target="_blank"
            >
              Division of Evaluation, Research, and Accountability.
            </a>
          </div>
          <div class="pb-2">
            Funded in part by a generous grant from the
            <a
              class="underline"
              href="https://williampennfoundation.org/"
              target="_blank"
            >
              William Penn Foundation.
            </a>
          </div>
          <div>
            Developed By
            <br />
            <a href="https://www.ipc-global.com/">
              <img
                class="w-20 mt-1"
                alt="IPC Global"
                src="~/assets/images/IPCGlobal-logo.png"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '~/components/Navigation/Navigation.vue'

export default {
  components: {
    Navigation
  },
  props: ['haslinks']
}
</script>
